import { Controller } from "@hotwired/stimulus"

// Mobile sidebar toggle.
// Expects a sidebar with id="sidebar" (off-canvas with -translate-x-full)
// and an overlay with id="sidebar-overlay" (hidden by default). The toggle
// button can live anywhere in the page and should have:
//   data-controller="mobile-sidebar"
//   data-action="click->mobile-sidebar#toggle"
//
// Closes on Escape and on Turbo navigation so the drawer never stays open
// across page changes (which would mask the new content and lock scroll).
export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    this.sidebarElement = this.hasSidebarTarget ? this.sidebarTarget : document.getElementById("sidebar")
    this.overlayElement = this.hasOverlayTarget ? this.overlayTarget : document.getElementById("sidebar-overlay")

    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    this._onNav = () => this.close()
    document.addEventListener("keydown", this._onKey)
    document.addEventListener("turbo:visit", this._onNav)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey)
    document.removeEventListener("turbo:visit", this._onNav)
    document.body.style.overflow = ""
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.sidebarElement || !this.overlayElement) {
      console.warn("Mobile sidebar: Missing sidebar or overlay element")
      return
    }

    const isOpen = !this.sidebarElement.classList.contains("-translate-x-full")
    isOpen ? this.close() : this.open()
  }

  open() {
    if (!this.sidebarElement || !this.overlayElement) return
    this.sidebarElement.classList.remove("-translate-x-full")
    this.overlayElement.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    this.element.setAttribute("aria-expanded", "true")
  }

  close() {
    if (!this.sidebarElement || !this.overlayElement) return
    this.sidebarElement.classList.add("-translate-x-full")
    this.overlayElement.classList.add("hidden")
    document.body.style.overflow = ""
    this.element.setAttribute("aria-expanded", "false")
  }
}
